export function isFreePlan(subscription) {
  return subscription === 'Free';
}
